import React from "react";
//#region types
import { NavLayoutMenuItem, NavigationLayoutMenuProps } from "models/propTypes/pageLayoutPropTypes";
//#endregion
//#region components
import { Grid, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import Icon from "../../icon";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const NavigationLayoutMenu: React.FC<NavigationLayoutMenuProps> = (props) => {
  const { menuItems, onMenuItemSelect, onSubMenuItemSelect, selectedMenuIndex, selectedSubMenuIndex } = props;

  return (
    <Grid item container className={cssExports.navLayoutMenu}>
      {menuItems.map((menuItem, menuIndex) => (
        <React.Fragment key={menuIndex}>
          {menuItem.menuSectionHeader && (
            <Grid item container className={cssExports.menuSectionHeader}>
              {LocalizationHelperInstance.getFormattedMessage(menuItem.menuSectionHeader)}
            </Grid>
          )}
          {menuItems.length === 1 ? (
            menuItem.subMenuItems?.map((subItem, subIndex) => (
              <MenuItem
                key={subItem.key}
                onClick={onSubMenuItemSelect.bind(null, subIndex)}
                className={clsx(cssExports.menuItem, subIndex === selectedSubMenuIndex ? cssExports.selected : "")}
              >
                {subItem.icon && (
                  <ListItemIcon className={cssExports.menuIcon}>
                    <Icon icon={subItem.icon} />
                  </ListItemIcon>
                )}

                <ListItemText className={cssExports.menuItemText}>
                  {subItem.label && LocalizationHelperInstance.getFormattedMessage(subItem.label)}
                </ListItemText>
              </MenuItem>
            ))
          ) : (
            <>
              <MenuItem
                key={menuItem.key}
                id={menuItem.key}
                onClick={onMenuItemSelect.bind(null, menuIndex)}
                className={clsx(cssExports.menuItem, menuIndex === selectedMenuIndex ? cssExports.selected : "")}
                // component={React.forwardRef<HTMLAnchorElement, any>((linkProps, ref) => (
                //   <Link to={`#${menuItem.key}`} {...linkProps} ref={ref as any} />
                // ))}
              >
                {menuItem.icon && (
                  <ListItemIcon className={cssExports.menuIcon}>
                    <Icon icon={menuItem.icon} />
                  </ListItemIcon>
                )}

                <ListItemText className={cssExports.menuItemText}>
                  {menuItem.label && LocalizationHelperInstance.getFormattedMessage(menuItem.label)}
                </ListItemText>
              </MenuItem>
              {menuIndex === selectedMenuIndex && menuItem.subMenuItems?.length && (
                <Grid item container direction={"column"} spacing={1} className={cssExports.subMenuContainer}>
                  {menuItem.subMenuItems.map((subItem: NavLayoutMenuItem, subIndex) => (
                    <MenuItem
                      key={`${subIndex}${subItem.key}`}
                      onClick={onSubMenuItemSelect.bind(null, subIndex)}
                      className={clsx(
                        cssExports.subMenuItem,
                        subIndex === selectedSubMenuIndex ? cssExports.selected : ""
                      )}
                    >
                      <ListItemText className={clsx(cssExports.menuItemText)}>
                        {subItem.label && LocalizationHelperInstance.getFormattedMessage(subItem.label)}
                      </ListItemText>
                    </MenuItem>
                  ))}
                </Grid>
              )}
            </>
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default NavigationLayoutMenu;
